import '@babel/polyfill'
import Vue from 'vue'
import VueEvents from 'vue-events'
import VueLogger from 'vuejs-logger'
import VueLodash from 'vue-lodash'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate from 'vee-validate'
import VueAuth from '@websanova/vue-auth'
import httpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js'
import routerVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js'
import { i18n } from './localization'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueCurrencyFilter from 'vue-currency-filter'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'

import './plugins/vuetify'
import QSPlugin from './plugins/vue-qs'
import App from './App.vue'
import router from './router'
import store from './store'

import SearchWidget from './components/SearchWidget'
import ResultsWidget from './components/ResultsWidget'
import FacetWidget from './components/FacetWidget'
import SearchToolbar from './components/SearchToolbar'
import Autocomplete from './components/Autocomplete'
import Lookup from './components/Lookup'
import ImageDialog from './components/ImageDialog'
import NoteDialog from './components/NoteDialog'
import AddQuoteDialog from './components/AddQuoteDialog'

import { CurrencyConfigEN } from './models/consts'

Vue.config.productionTip = false

Vue.use(VueLogger, {
  // optional : defaults to true if not specified
  isEnabled: process.env.VUE_APP_LOG_ENABLED === 'true',
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: false,
  // optional : defaults to false if not specified
  showMethodName: false,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: false
})

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 10000
  }
})
Vue.use(VueLodash, { name: 'lodash' })
Vue.use(VueEvents)
Vue.use(VueMoment, {
  moment
})
moment.tz.setDefault('Europe/London')
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_ROOT_API
Vue.router = router
Vue.use(VueAuth, {
  parseUserData: function (data) {
    if (data.data.cart) {
      store.dispatch('quote/loadCart', data.data.cart)
    }
    return data.data || {}
  },
  jwtTokens: ['AccessToken', 'RefreshToken'],
  auth: {
    request: function (req, token) {
      const refresh = req.url.indexOf('refresh') > -1
      token = token.split(';')
      if (!refresh) {
        this.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + token[0] })
      } else {
        this.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + token[1] })
        // req.data = { 'refresh_token': token[1] }
      }
      // token = req.url.indexOf('refresh') > -1 ? token[1] : token[0]
      // this.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    },
    response: function (res) {
      if (res.data.access_token && res.data.refresh_token) {
        return res.data.access_token + ';' + res.data.refresh_token
      }
    }
  },
  // auth: {
  //   request: function (req, token) {
  //     let tokens = token.split(';')
  //     this.options.jwtTokens.forEach((tokenName, index) => {
  //       if (tokens[index]) {
  //         this.http.setHeaders.call(this, req, { [tokenName]: tokens[index] })
  //       }
  //     })
  //     token = req.url.indexOf('refresh') > -1 ? tokens[1] : tokens[0]
  //     this.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
  //   },
  //   response: function (res) {
  //     if (res.data.access_token && res.data.refresh_token) {
  //       Vue.$log.debug(`Access Token: ${res.data.access_token}`)
  //       Vue.$log.debug(`Refresh Token: ${res.data.refresh_token}`)
  //       return res.data.access_token + ';' + res.data.refresh_token
  //     }
  //   }
  // },
  // auth: {
  //
  //   request: function (req, token) {
  //     this.http.setHeaders.call(this, req, {
  //       Authorization: 'Bearer ' + token
  //     })
  //   },
  //
  //   response: function (res) {
  //     let headers = this.http.getHeaders.call(this, res)
  //     let token = headers.Authorization || headers.authorization
  //
  //     if (token) {
  //       token = token.split(/Bearer:?\s?/i)
  //
  //       return token[token.length > 1 ? 1 : 0].trim()
  //     }
  //   }
  // },
  http: httpAxios,
  router: routerVueRouter,
  token: [ { request: 'token', response: 'token', authType: 'bearer', foundIn: 'header' } ],
  tokenName: 'token',
  loginData: { url: 'auth/login', method: 'POST', redirect: '/', fetchUser: true },
  refreshTokenName: 'refresh_token',
  refreshData: { url: 'auth/refresh', method: 'GET', enabled: true, interval: process.env.VUE_APP_REFRESH_TOKEN_INTERVAL || 17 },
  rolesVar: 'roles'
})

Vue.use(VeeValidate, {
  dictionary: {
    en: {
      custom: {
        confirm: {
          required: () => 'The confirm password field is required.'
        },
        name: {
          required: 'Please enter a quote or order name'
        },
        thirdPartyAddress: {
          required: 'Please enter a third-party address'
        },
        thirdPartyTelephone: {
          required: 'Please enter a third-party telephone number'
        },
        submissionType: {
          required: 'Please select if this is a quote or an order'
        }
      }
    }
  }
})

Vue.axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response.status === 401 && error.response.statusText === 'UNAUTHORIZED') {
    // Vue.$log.debug('UNAUTHORIZED')
    // const token = Vue.$auth.token()
    // Vue.$log.debug(token)
    // const tokens = token.split(';')
    // Vue.$log.debug(tokens[0])
    // Vue.$log.debug(tokens[1])
    // Vue.auth.refresh()
    Vue.auth.logout({
      makeRequest: false,
      redirect: { name: 'login' }
    })
  }
  return Promise.reject(error)
})

Vue.use(QSPlugin)
Vue.use(VueCurrencyFilter, CurrencyConfigEN)

// Component registrations
Vue.component('search-widget', SearchWidget)
Vue.component('results-widget', ResultsWidget)
Vue.component('facet-widget', FacetWidget)
Vue.component('search-toolbar', SearchToolbar)
Vue.component('autocomplete', Autocomplete)
Vue.component('lookup', Lookup)
Vue.component('image-dialog', ImageDialog)
Vue.component('note-dialog', NoteDialog)
Vue.component('add-quote-dialog', AddQuoteDialog)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
